export const removeArrayIndexesFromPath = (str: string) =>
  str.replace(/ *\[[^\]]*] */g, "");
